webpackJsonp([7],{

/***/ "4DH0":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "div.loading[data-v-b11c9d42]{min-height:65vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}div.loading-item[data-v-b11c9d42]{display:block;text-align:center}div.loading span.title[data-v-b11c9d42]{display:block;font-size:1.7em}.button-group[data-v-b11c9d42]{margin-top:40px;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.button-group button[data-v-b11c9d42]{height:80px;width:400px}", "", {"version":3,"sources":["/home/gitlab-runner/builds/6c4bbb72/0/otc/dadosabertos/frontend/src/views/public/receitas_despesas/index.vue"],"names":[],"mappings":"AACA,6BACE,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,kCACE,cAAe,AACf,iBAAmB,CACpB,AACD,wCACE,cAAe,AACf,eAAiB,CAClB,AACD,+BACE,gBAAiB,AACjB,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC3B,2BAA4B,AACxB,4BAA8B,CACvC,AACD,sCACE,YAAa,AACb,WAAa,CACd","file":"index.vue","sourcesContent":["\ndiv.loading[data-v-b11c9d42] {\n  min-height: 65vh;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\ndiv.loading-item[data-v-b11c9d42] {\n  display: block;\n  text-align: center;\n}\ndiv.loading span.title[data-v-b11c9d42] {\n  display: block;\n  font-size: 1.7em;\n}\n.button-group[data-v-b11c9d42] {\n  margin-top: 40px;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n}\n.button-group button[data-v-b11c9d42] {\n  height: 80px;\n  width: 400px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "CtSO":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4DH0");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5c8201ec", content, true, {});

/***/ }),

/***/ "JwOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common__ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_colors__ = __webpack_require__("ZAg2");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_2__components_common__["a" /* PublicHeader */],
    BarChart: __WEBPACK_IMPORTED_MODULE_2__components_common__["d" /* BarChart */],
    AnoBase: __WEBPACK_IMPORTED_MODULE_2__components_common__["j" /* AnoBase */]
  },
  data: function data() {
    return {
      // ano_base: new Date().getFullYear(),
      chart_base: { labels: __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mesesAbr */], datasets: [{ label: '', data: [] }] },
      chart_option: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          labels: {
            fontColor: '#C1D1C1'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              suggestedMax: 50,
              fontColor: '#C1D1C1',
              callback: function callback(value, index, values) {
                return value.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL'
                });
              }
            }
          }],
          xAxes: [{
            maxBarThickness: 50,
            ticks: {
              fontColor: '#C1D1C1'
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function label(tooltip, dataset) {
              var xLabel = dataset.datasets[tooltip.datasetIndex].label;
              var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
              });
              return xLabel + ': ' + yLabel;
            }
          }
        }
      }
    };
  },
  methods: {
    formatarMoeda: __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* formatarMoeda */],
    filtrarPorCodigo: function filtrarPorCodigo(codigo) {
      var receitas_proprias = this.$store.state.receitas_despesas.receitas_proprias;


      var filterByID = function filterByID(obj) {
        if ('cd_plano_conta_rel' in obj && obj.cd_plano_conta_rel === codigo) {
          return true;
        } else {
          return false;
        }
      };

      var atual = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, receitas_proprias.filter(filterByID));

      return { atual: atual[0] };
    },
    retornaSomaPorKey: function retornaSomaPorKey(key) {
      var detalhamento_despesas = this.$store.state.receitas_despesas.detalhamento_despesas;


      var reducer = function reducer(acumulador, atual) {
        return acumulador + atual[key];
      };

      var resultAtual = detalhamento_despesas.reduce(reducer, 0);

      return {
        atual: resultAtual
      };
    },
    retornaAtualPorKey: function retornaAtualPorKey(key) {
      var detalhamento_despesas = this.$store.state.receitas_despesas.detalhamento_despesas;


      var reducer = function reducer(acumulador, atual) {
        return acumulador + atual[key];
      };

      var resultAtual = detalhamento_despesas.reduce(reducer, 0);

      return resultAtual;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    ano_base: function ano_base(state) {
      return state.receitas_despesas.ano_base;
    }
  }), {
    loading: function loading() {
      return this.receitas.length === 0;
    },
    receitas: function receitas() {
      return this.$store.state.receitas_despesas.receitas_proprias;
    },
    graficoOrcadaEmpenhada: function graficoOrcadaEmpenhada() {
      var receita_corrente = this.filtrarPorCodigo('1').atual;
      var receita_capital = this.filtrarPorCodigo('2').atual;

      var previsto = Number(receita_corrente.vl_atualizado_f) + Number(receita_capital.vl_atualizado_f);

      var data = [];

      for (var index = 0; index < __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mesesAbr */].length; index++) {
        var element = __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mesesAbr */][index].toLowerCase();

        if (receita_corrente['vl_' + element + '_f'] === '0' && receita_capital['vl_' + element + '_f'] === '0') {
          break;
        }

        data.push((data[index - 1] || 0) + this.retornaAtualPorKey('vl_' + element + '_emp'));
      }

      var datasets = [{
        type: 'line',
        label: 'Receita Orçada',
        data: Array(12).fill(previsto),
        fill: false,
        borderColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors__["a" /* default */].coresRGB[0],
        backgroundColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors__["a" /* default */].coresRGB[0]
      }, {
        label: 'Despesa Empenhada',
        data: data,
        backgroundColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors__["a" /* default */].coresRGB[1]
      }];
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.chart_base, {
        datasets: datasets
      });
    },
    graficoArrecadadaPaga: function graficoArrecadadaPaga() {
      var dadosCorrente = this.filtrarPorCodigo('1');
      var dadosCapital = this.filtrarPorCodigo('2');
      var data = [],
          pagamentos = [];

      for (var index = 0; index < __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mesesAbr */].length; index++) {
        var element = __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mesesAbr */][index].toLowerCase();

        if (dadosCorrente.atual['vl_' + element + '_f'] === '0' && dadosCapital.atual['vl_' + element + '_f'] === '0') {
          break;
        }

        pagamentos.push((pagamentos[index - 1] || 0) + this.retornaAtualPorKey('vl_' + element + '_pag'));

        var soma = Number(dadosCorrente.atual['vl_' + element + '_f']) + Number(dadosCapital.atual['vl_' + element + '_f']);
        data.push((data[index - 1] || 0) + soma);
      }

      var datasets = [{
        label: 'Receita Arrecadada',
        data: data,
        borderColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors__["a" /* default */].coresRGB[0]
      }, {
        label: 'Despesa Paga',
        data: pagamentos,
        backgroundColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors__["a" /* default */].coresRGB[1]
      }];
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.chart_base, {
        datasets: datasets
      });
    },
    orcamentoAtual: function orcamentoAtual() {
      var loading = this.loading,
          formatarMoeda = this.formatarMoeda,
          filtrarPorCodigo = this.filtrarPorCodigo;


      if (loading) {
        return formatarMoeda(0);
      }

      var receitaCorrente = filtrarPorCodigo('1').atual.vl_atualizado_f;
      var receitaCapital = filtrarPorCodigo('2').atual.vl_atualizado_f;

      return Number(receitaCorrente) + Number(receitaCapital);
    },
    receitaAtual: function receitaAtual() {
      var loading = this.loading,
          formatarMoeda = this.formatarMoeda,
          filtrarPorCodigo = this.filtrarPorCodigo;


      if (loading) {
        return formatarMoeda(0);
      }

      var receitaCorrente = filtrarPorCodigo('1').atual.vl_total_f;
      var receitaCapital = filtrarPorCodigo('2').atual.vl_total_f;

      return Number(receitaCorrente) + Number(receitaCapital);
    },
    despesaAnualPrevista: function despesaAnualPrevista() {
      return this.retornaSomaPorKey('vl_previsto');
    },
    despesaAnualPaga: function despesaAnualPaga() {
      return this.retornaSomaPorKey('vl_total_pag');
    }
  })
});

/***/ }),

/***/ "U6dw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("JwOX");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b11c9d42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("ulTP");
function injectStyle (ssrContext) {
  __webpack_require__("CtSO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b11c9d42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b11c9d42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ulTP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-item"},[_c('font-awesome-icon',{attrs:{"icon":"spinner","size":"3x","spin":""}}),_vm._v(" "),_vm._m(0)],1)]):_c('div',{staticClass:"row receitas"},[_c('public-header',{attrs:{"title":'Receita e Despesas'}},[_c('ano-base',{staticClass:"margem-bottom"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        Aqui você encontra um resumo das receitas e despesas gerenciadas pela\n        Prefeitura Municipal de Santos.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Para o ano de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.ano_base))]),_vm._v(", foi orçada uma receita total no valor de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.formatarMoeda(_vm.orcamentoAtual)))]),_vm._v(", com uma previsão de gastos no valor de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v("\n          "+_vm._s(_vm.formatarMoeda(_vm.despesaAnualPrevista.atual))+".\n        ")])]),_vm._v(" "),_c('p',[_vm._v("\n        Até a presente data, houve uma arrecadação no valor de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v("\n          "+_vm._s(_vm.formatarMoeda(_vm.receitaAtual))+"\n        ")]),_vm._v("\n        e um total de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v("\n          "+_vm._s(_vm.formatarMoeda(_vm.despesaAnualPaga.atual))+"\n        ")]),_vm._v("\n        em despesas pagas.\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('bar-chart',{ref:"orcada_empenhada",attrs:{"chart-data":_vm.graficoOrcadaEmpenhada,"gradiente":false,"coloredLine":true,"options":Object.assign({}, _vm.chart_option,
          {title: {
            display: true,
            text: 'Receita orçada x Despesa Empenhada',
            fontColor: '#C1D1C1'
          }})}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('bar-chart',{ref:"arrecadada_paga",attrs:{"chart-data":_vm.graficoArrecadadaPaga,"gradiente":false,"coloredLine":true,"options":Object.assign({}, _vm.chart_option,
          {title: {
            display: true,
            text: 'Receita arrecadada x Despesa paga',
            fontColor: '#C1D1C1'
          }})}})],1)],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',{},[_vm._v("Receitas e Despesas")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Para mais informações")]),_vm._v(" "),_c('p',[_vm._v("\n          Abaixo, você poderá consultar um resumo de todas as receitas\n          correntes e de capital administradas pela Prefeitura Municipal de\n          Santos, o acompanhamento mensal e poderá navegar através dos\n          diferentes níveis de informação.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Poderá consultar também o resumo das despesas efetuadas pela\n          prefeitura, a previsão de gastos, os valores empenhados, liquidados\n          e pagos mensalmente, o total de gastos agrupado por unidade\n          executora da despesa, pelas diferentes áreas (segurança pública,\n          educação, etc.), além do detalhamento de cada despesa uma das\n          despesas.\n        ")]),_vm._v(" "),_c('div',{staticClass:"button-group"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"tag":"button","to":{ name: 'receitas' }}},[_vm._v("Receitas")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"tag":"button","to":{ name: 'despesas' }}},[_vm._v("Despesas")])],1)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"title"},[_vm._v("Olá, é a sua primeira vez aqui? "),_c('br'),_vm._v("\n      Por favor aguarde, estamos carregando as informações de receitas para\n      você.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.2f79022e90ed43271475.js